import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/unselect-all.svg
 */
const IconUnselectAll: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4H4v6h6V4zM3 3v8h8V3H3zM10 14H4v6h6v-6zm-7-1v8h8v-8H3z"
      fill="currentColor"
    />
    <path d="M13 5h8v4h-8V5zM13 15h8v4h-8v-4z" fill="currentColor" />
  </svg>
);

export default IconUnselectAll;
